import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom/client';
import Styled from 'styled-components';
import './style.css';

export const Body = Styled.div`
	position: fixed;
	z-index: 1;
	padding-top: 100px;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	overflow: auto;
	background-color: rgb(0,0,0);
	background-color: rgb(0,0,0,0.4);
	
	.modalBtn #modalBtnCancel, #modalBtnOk {
		margin: 0;
		width: 60px;
		height: 30px;
		border: none;
		background-color: #1576d1;
		color: #fff;
		border-radius: 8px;
	}
	#modalBtnOk {
	}
	#modalBtnCancel {
		background-color: #666666;
	}

	#modal-header-panel {
		margin: 0px 10px;
		font-weight: bolder;
		line-height: 48px;
		display: flex;
		justify-content: space-between;	}
		
	/* Modal Content */
	#Popup .modal-content {
	background-color: #fefefe;
	margin: auto;
	padding: 10px;
	border: 1px solid #888;
	width: 30%;
    border-radius: 10px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
	}
	
	/* The Close Button */
	#Popup .closeBtn {
	color: #aaaaaa;
	font-size: 28px;
	font-weight: bold;
	}
	
	#Popup .closeBtn: hover,
	#Popup .closeBtn: focus {
	color: #000;
	text-decoration: none;
	cursor: pointer;
	}
`;


let Result = {};

let CurrentModalInfo = {};

export const GetResult = () => {
	return Result;
}

export const SetResult = (Value) => {
	Result = Value;
}

export const ShowModal = (ModalInfo)=> {
	setTimeout(() => {
		let modal = document.getElementById(ModalInfo.ModalName);
		let render = modal.children[0].children[0].children[0].children[2];
		console.log("InitializeModal:" + ModalInfo.ModalName);
		
		if (modal !== null) {
		modal.style.display = "";
		ReactDOM.render(ModalInfo.Page, render);
		SetResult(undefined);
		CurrentModalInfo[ModalInfo.ModalName] = ModalInfo;
		document.body.style.overflow = 'hidden';
	}
	}, 250);
}

export const ShowPopupModal = (ModalInfo) => {
	setTimeout(() => {
		let modal = document.getElementById(ModalInfo.ModalName);
		let popupModal = modal.children[0].children[0];
		let renderContainer = modal.children[0].children[0].children[0].children[2];
		console.log("InitializeModal:" + ModalInfo.ModalName);
		
		if (modal !== null) {
			modal.style.display = '';
			popupModal.className = 'modalOpen';
			document.body.style.overflow = 'hidden';

            // Create a root and render the component
            ReactDOM.createRoot(renderContainer).render(ModalInfo.Page);

			SetResult(undefined);
			CurrentModalInfo[ModalInfo.ModalName] = ModalInfo;
		}
	}, 450);
}

export let formClose = (ModalName) => {
	CurrentModalInfo[ModalName].GetResult(GetResult());
	let modal = document.getElementById(CurrentModalInfo[ModalName].ModalName);
	let render = modal.children[0].children[0].children[0].children[2];
	modal.style.display = "none";
	document.body.style.overflow = 'auto';
	ReactDOM.createRoot.render(<div />, render);
	CurrentModalInfo[ModalName] = undefined;
}	

export let formCloseDialogResult = (ModalName, isResult) => {
	SetResult({ ...Result, isDialogResult: isResult });
	CurrentModalInfo[ModalName].GetResult(GetResult(isResult));
	let modal = document.getElementById(CurrentModalInfo[ModalName].ModalName);
	let render = modal.children[0].children[0].children[0].children[2];
	modal.style.display = "none";
	document.body.style.overflow = 'auto';
	ReactDOM.render(<div />, render);
	CurrentModalInfo[ModalName] = undefined;
}

export let resFormClose = (isResult, ModalInfo) => {
	if (isResult === true) {
		SetResult({ ...Result, isDialogResult: isResult });
		ModalInfo.GetResult(GetResult(isResult));
	}
	let modal = document.getElementById(ModalInfo.ModalName);
	let render = modal.children[0].children[0].children[0].children[2];
	modal.style.display = "none";
	document.body.style.overflow = 'auto';
	ReactDOM.render(<div />, render);
}

function Modal(Props) {
	useEffect(() => {
		InitializeComponent();
	}, []);
	
	const modalRef = useRef();
	
	let InitializeComponent = () => {
		let modal = document.getElementById(Props.ModalInfo.ModalName);
		document.body.style.overflow = 'auto';
		modal.style.display = "none";
	}
	
	let formClose = (isResult) => {
		if (isResult === true) {
			SetResult({ ...Result, isDialogResult: isResult });
			Props.ModalInfo.GetResult(GetResult(isResult));
		}
		let modal = document.getElementById(Props.ModalInfo.ModalName);
		let render = modal.children[0].children[0].children[0].children[2];
		modal.style.display = "none";
		document.body.style.overflow = 'auto';
	}
		
	return (
		<Body id={Props.ModalInfo.ModalName}>
			<div style={{ width: '100%' }}>
				<div id = "Popup" className="modal">
					<div className="modal-content" style={{ width: Props.ModalInfo.Width, height: Props.ModalInfo.Height }}>
						<div id="modal-header-panel">
							<label style={{color: 'black', FontFamily: 'NotoSans Cjk KR', fontSize: '13pt', fontWeight: '1000' }}>{Props.ModalInfo.Title}</label>
							<span className="closeBtn" onClick={() => formClose(false)}>&times;</span>
						</div>
						<hr />
                        <div className='modalBtn'>
						<button id='modalBtnOk' type="primary" size="small" onClick={(e) => formClose(true, Props.ModalInfo)} style={{ marginLeft: '10px', display: Props.ModalInfo.isHideOk === true ? 'none' : ''}}> 확인 </button>
						<button id='modalBtnCancel' type="default" size="small" onClick={(e) => formClose(false)} style={{marginLeft: '10px', display: Props.ModalInfo.isCancel === true ? '' : 'none' }}> 취소 </button>
						</div>
					</div>
				</div>
			</div>
	</Body>
  );
}
 
export default { Modal, ShowModal, GetResult, SetResult, formClose, formCloseDialogResult, resFormClose, ShowPopupModal };
